
import React, { useEffect, useState, useCallback } from "react";

import { Route, Routes } from "react-router";
import Todo from "./pages/todoapp/Todo";
// import 'antd/dist/antd.css'
import "antd/dist/antd.min.css";
import Homepage from "./pages/home/index";
import Home from "./pages/home/home";
import PageContent from "./pages/home/pagecontent";
import TourManagement from "./pages/management/index";
import AdminManagement from "./pages/admin-management/index";
import UsersManagement from "./pages/users-management/index";
import MainLayOut from "./components/shares/layout";
import LayoutMangement from "./components/shares/layoutmanagement";
import EventManagement from "./pages/management/EventManagement";
import ServiceManagement from "./pages/management/ServiceManagement";
import EventCategoryManagement from "./pages/management/EventCategoryManagement";
import ServiceCategoryManagement from "./pages/management/ServiceCategoryManagement";
import AdsManagement from "./pages/management/AdsManagement";
import Province from "./pages/management/ProvinceManagement";
import Provider from "./pages/management/ProviderManagement";
import BannersManagement from "./pages/management/BannersManagement";
import ContentsManagement from "./pages/management/ContentsManagement";
import Login from "./pages/login";
import provinceApi from "./service/provinceService";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentLocation } from "./features/currentLocationRedux/currentLocation";
import { useNavigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const adminAuthen = useSelector((state) => state.adminAuthen);
  // console.log(`App check login :${JSON.stringify(adminAuthen)}`)
//   provinceApi.getRegionByIp().then((res) => {
//     const loc = res.loc != '' ? res.loc.split(',') : '';
//     const result = {
//       // city: res.city,
//       // region: res.region,
//       // country: res.country,
//       // postal: res.postal,
//       latitude : loc[0],
//       longitude : loc[1],
//     }
//     dispatch(updateCurrentLocation(result));     
// })  
  // const [token, setToken] = useState();

  // if(!token) {
  //   return <Login setToken={setToken} />
  // }

  // useEffect(() => {
  // const isReadyAuthen = isAuthen()
  // console.log(`App effect isReadyAuthen :${JSON.stringify(isReadyAuthen)}`)
  //   if (isReadyAuthen) {
  //     navigate("/management");
  //   }else{
  //     navigate("/management/login");
  //   }
  // },[adminAuthen]);
  
  // const isAuthen = () => { return (adminAuthen.user != null && adminAuthen.tokenData != null)}
  

  return (
    <Routes>
      <Route element={<MainLayOut />}>
        <Route path="/" element={<Homepage />} />
        {/* <Route path="/location/:paramCategoryId/:locationId" element={<Homepage />} /> */}
        {/* <Route path="/:tab/:paramCategoryId/:locationId" element={<Homepage />} /> */}
        {/* <Route path="/:tab/:locationId" element={<Homepage />} />
        <Route path="/tim-dia-diem" element={<Homepage />} /> */}
        <Route path="/:slug" element={<PageContent />} />
      </Route>
      
      <Route element={<LayoutMangement />}>
        <Route path="/management" element={<TourManagement />} />
        <Route path="/management/event" element={<EventManagement />} />
        <Route path="/management/location-tour" element={<TourManagement />} />
        <Route
          path="/management/location-service"
          element={<ServiceManagement />}
        />
        {/* <Route path="/management/user" element={<TourManagement />} /> */}
        <Route
          path="/management/event-category"
          element={<EventCategoryManagement />}
        />
        <Route
          path="/management/service-category"
          element={<ServiceCategoryManagement />}
        />
        <Route
          path="/management/ads-category"
          element={<AdsManagement />}
        />
        <Route path="/management/admin" element={<AdminManagement />} />
        <Route path="/management/users" element={<UsersManagement />} />
        <Route path="/management/province" element={<Province />} />
        <Route path="/management/provider" element={<Provider />} />
        <Route path="/management/banners" element={<BannersManagement />} />
        <Route path="/management/contents" element={<ContentsManagement />} />
      </Route>

    

      <Route path="/todo" element={<Todo />} />
      <Route path="/management/login" element={<Login />} />
    </Routes>
  );
}
